import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Icon10 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon9 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import Instructor2 from "../../../../../assets/images/png/courses/instructors/jefferson.webp";
import Instructor1 from "../../../../../assets/images/png/courses/instructors/raphael.jpg";

import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/isdon.webp";
import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/okoli.webp";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/product.webp";

import BusinessImage from "../../../../../assets/images/svg/business.svg";
import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const cloudDevelopmentEurope = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Cloud Bootcamp",
  description: `
  This training is designed by top professionals to help you learn 
  the latest skills of the Cloud Developer using Microsoft Azure program, you will 
  learn how to deploy, build, migrate, and monitor applications on Azure. 
    `,
  duration: "16 Weeks",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1lJsXQWQ40TMoa0XFf0OHjybgnU2JQk1e/view?usp=sharing",

  bookCallUrl: "https://calendar.app.google/4CH6CdurjV6h22oW9",
  chatWithUsUrl: "https://wa.me/12028217864",

  courseFormUrl: "courses/cloud-bootcamp/fill-form",

  jobTitle: "Cloud Developer",

  kickoffDate: "December 2",
  kickoffTime: "4:00 PM - 8:00 PM (GMT +1)",

  testimonial: {
    image: Testimony2,
    name: "Kenchukwu Okoli",
    role: "Cloud Fellow",
    testimony: `
    My Cloud developers learning with Utiva has been very intense. I have 
      been drilled with the necessary skills and attitude that a cloud developer 
      practicing in the industry  should have. Areas covered in the training are 
      areas in cloud computing that existing cloud service providers use to 
      carry out their day to day task. Tutoring is being led by experienced cloud 
      expert currently practicing in the industry. He has given us practical cloud 
      projects to execute and write technical report and blogs about what we have 
      learnt, this is to reinforce the knowledge so that it sticks. It's been so beneficial. 
      I wish the program never ends. 
      Everyone should hurry and join the Utiva community now.`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Learn Cloud Computing Best Practices Live, Led by Experienced Cloud Professionals and Get Prepared for Global Jobs`,
    desc: `
    According to 2021 Cloud research, Microsoft Azure is one of the most popular 
    cloud services platforms used by enterprises in fast-rising economies, 
    making it a crucial tool for cloud computing professionals to add to their 
    skillset. The Cloud Developer using Microsoft Azure program 
    will help you learn how to deploy, build, migrate, and monitor applications on Azure.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Describe core Azure concepts",
      unitTag:
        "Azure architecture components such as subscriptions, management groups, resources and resource groups, Azure regions, region pairs, and availability zones.",
      unitDescription: `
      This module is developed for those that are new to the entire cloud concept 
      and will cover the Microsoft accredited six-part series that teaches 
      you basic cloud concepts, provides a streamlined overview of many Azure services, and 
      guides you with hands-on exercises to deploy your very first services for free.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Azure fundamentals",
          featureDescription: `This module introduces you to the basics of cloud 
          computing and Azure, and how to get started with Azure's subscriptions and accounts.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Discuss Azure fundamental concepts",
          featureDescription: `
          Are you interested in the cloud, but aren't sure what it can do for you? 
          In this module, you'll learn about the advantages of using cloud computing services, 
          and you'll learn to differentiate between the categories and types of cloud computing.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Visualization",
          featureDescription: `In this module, you'll examine the various concepts, r
          esources, and terminology that are necessary to work with Azure architecture. 
          For example, you'll learn about Azure subscriptions and management groups, resource groups and 
          Azure Resource Manager, as well as Azure regions and availability zones.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Describe core Azure services",
      unitTag:
        " Azure compute services, Azure networking services, Azure Storage services, Azure database and analytics services.",
      unitDescription: `
      Introduction to Microsoft Azure fundamentals and core Azure architectural components. 
      This section helps you to know the 
      Microsoft Azure compute services, storage services, analytics and database.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Explore Azure compute services",
          featureDescription: `In this module, you'll learn how to take 
          advantage of several virtualization services in Azure compute, which can 
          help your applications scale out quickly and efficiently to meet increasing demands.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Explore Azure networking services",
          featureDescription: `
          In this module, you'll take a look at several of the core networking 
          resources that are available in Azure. You'll learn about Azure Virtual 
          Network, which you can configure into a customized network environment 
          that meets your company's needs. You'll also learn how you can use Azure VPN Gateway and Azure ExpressRoute to 
          create secure communication tunnels between your company's different locations.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Explore Azure Storage services",
          featureDescription: `In this module, you'll learn about some of the different 
          storage options that are available in Azure Storage services, and the scenarios 
          in which each storage option is appropriate. As you complete the individual units in this module, you'll 
          learn about Azure Blob Storage, Azure Disk Storage, Azure Files, and Blob access tiers.`,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Explore Azure database and analytics services",
          featureDescription: `In this module, you'll learn about several of the database 
            services that are available on Microsoft Azure, such as Azure Cosmos DB, 
            Azure SQL Database, Azure SQL Managed Instance, Azure Database for MySQL, and Azure Database for PostgreSQL. 
            In addition, you'll learn about several of the big data and analysis services in Azure.`,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Describe core solutions and management tools on Azure",
      unitTag: `
      Know the best AI service for your needs, best Azure serverless 
      technology for your business scenario, know the best tools to 
      help organizations build better solutions, know the best tools 
      for managing and configuring your Azure environment, 
      know the best monitoring service for visibility, insight, and outage mitigation.
      `,
      unitDescription: `
      You will have to learn all the tools and services from Microsoft Azure. 
      In this learning path, you'll be introduced to many of these tools and services and 
      will be asked to help choose the best one for a given business scenario.
          `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Choose the best AI service for your needs",
          featureDescription: `Examine Azure's AI services, and choose the right one for your company.`,
        },
        {
          featureIcon: Icon9,
          featureTitle:
            "Choose the best Azure serverless technology for your business scenario",
          featureDescription: `Examine Azure serverless technologies, and choose the right service for your business scenario.`,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Choose the best tools to help organizations build better solutions",
          featureDescription: `Learn about Microsoft tools and services that help developers 
          and operations engineers build modern solutions for the cloud and on-premises.`,
        },
        {
          featureIcon: Icon8,
          featureTitle:
            "Choose the best tools for managing and configuring your Azure environment",
          featureDescription: `Explore the Azure management, administration, 
            and reporting tools, and choose the ones that best meet your organization's needs.`,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Describe general security and network security features",
      unitTag: `Deploy the different strategies for protection against threat and securing your network connectivity on Microsoft Azure.,
      Protect against security threats on Azure, Secure network connectivity on Azure`,
      unitDescription: `
      This module will teach about the various Azure services 
      you can use to help ensure that your cloud resources 
      are safe, secure, and trusted. Every application and service, 
      whether on-premises or in the cloud, needs to be designed 
      with security in mind. Security 
      needs to happen at the application level, at the data 
      level, and at the network level.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Protect against security threats on Azure",
          featureDescription: `Learn how Azure can help you protect the workloads 
            that you run both in the cloud and in your on-premises datacenter.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Secure network connectivity on Azure",
          featureDescription: `Learn about the Azure services you can use to help ensure that your network is safe, secure, and trusted.`,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle:
        "Describe identity, governance, privacy, and compliance features",
      unitTag: ` Examine privacy, compliance, and data protection standards 
      on Azure. Learn about Microsoft's commitment to 
      privacy and how Azure adheres to common regulatory and compliance standards.`,
      unitDescription: `
        Learn how Azure can help you secure access to cloud resources, what it means to build 
        a cloud governance strategy, and how Azure adheres to common regulatory and compliance standards.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Secure access to your applications by using Azure identity services",
          featureDescription: `Learn how Azure Active Directory helps you manage and secure identities. 
          Also see how single sign-on, multi factor authentication, and Conditional Access enable your users to 
          securely access resources and applications from your intranet and from public networks.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Build a cloud governance strategy on Azure",
          featureDescription: `Learn how access policies, resource locks, and tags, as well as Azure 
          services such as Azure Policy and Azure Blueprints, 
          can help you build a comprehensive cloud governance strategy.`,
        },
        {
          featureIcon: Icon3,
          featureTitle:
            "Examine privacy, compliance, and data protection standards on Azure",
          featureDescription: `Learn about Microsoft's commitment to privacy and how 
            Azure adheres to common regulatory and compliance standards.`,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Describe Azure cost management and service level agreements",
      unitTag: `Manage your Microsoft Azure costs, and choose the right 
      Microsoft Azure services by examining SLAs and service lifecycle.`,
      unitDescription: `
      Learn about the factors that influence cost, tools you can use to 
      help estimate and manage your cloud spend, and how Azure's service-level 
      agreements (SLAs) can impact your application design decisions.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Plan and manage your Azure costs",
          featureDescription: `Learn about the factors that influence cost 
          and tools you can use to help estimate and manage your cloud spend.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Choose the right Azure services by examining SLAs and service lifecycle",
          featureDescription: `Learn about service-level agreements (SLAs) in 
          Azure, and how they can affect your application design decisions. See 
          how to access preview services and learn how they affect your planning.`,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Databases – Database Types, SQL, Use Cases",
      unitTag: `Apply SQL by querying a relational database to bring data to the 
      surface. You will manipulate data using SQL to draw insights.`,
      unitDescription: `
      Learn how to organize data within a database, and access it using 
      Structured Querying Language (SQL). Develop core querying skills, 
      including how to manipulate 
      data within a database and connect your data to other tools.
        `,
    },
    {
      unitId: 8,
      unitTitle: "Azure Applications",
      unitTag: ` Introduction to Microsoft Azure Development, Azure Compute Services, 
      Azure Storage Options and Security, and Monitoring Basics`,
      unitDescription: `
      In this course, you will learn the basics of deploying an application 
      to Azure. Understand the benefits and costs of cloud deployments, 
      different types of service models, and how to navigate the Microsoft 
      Azure platform. Distinguish two types of compute services in Azure, 
      virtual machines and app services, when to use 
      each, and how to deploy applications onto the related service. 
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Microsoft Azure Development",
          featureDescription: `You'll learn to assess the value, cost, and 
          benefits of hosting applications and systems in the cloud
          You'll also learn to interpret the benefits/challenges of IaaS vs. 
          PaaS vs. SaaS and where Microsoft Azure fits into each of these 
          and finally learn to navigate the Azure Portal. 
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Azure Compute Services",
          featureDescription: `You will learn to choose the correct Azure Compute 
          Service for their applications and storage needs. You will learn to Create a 
          Subscription and Resource Group. TO manage and clean up Resource Groups.
          You will learn how to create a Linux VM, an App Service and App Service Plan. 
          Also learn how to manage basic app service settings and justify which resource to use for app deployment based
           on costs, scalability, availability and workflow.
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Azure Storage Options",
          featureDescription: `You will master how to create a SQL Database in Azure. 
          And also you will learn to make updates to the schema of an Azure SQL Database 
          and add data to it. Also, you will learn to create an Azure Blob Storage Container. 
          You will learn to upload blobs to the container
          And also learn to set up configurations for an app service to connect 
          to both a SQL Database and Azure Blob Storage Container.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Security and Monitoring Basics",
          featureDescription: `You will learn to differentiate security options between different Azure resources
          And also learn to compare security responsibilities between the developer and cloud provider 
          for different applications. Also, You will learn to implement OAuth2 such as Sign in with 
          Microsoft in their apps. And finally learn to utilize Azure Active Directory for single 
          sign-on and multi-factor authentication in their app. 
          Monitor and analyze the log output of an app service running in Azure.
          
          `,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Azure Microservices",
      unitTag: `Introduction to Microservices, Serverless Functions, 
      Enterprise Logic Apps and Event Grid, Deploying Your Services`,
      unitDescription: `
      In this course, you will learn how to implement a serverless microservice 
      back-end architecture in Python using Azure cloud serverless offerings. 
      You’ll compare and contrast common Azure microservices architecture and 
      compute options, configure an instance of a MongoDB database with Azure 
      CosmosDB, and allow the API to talk to this database. You will also apply 
      Enterprise Logic Apps and Event Grid to structure an application workflow. 
      Finally, you’ll deploy published API endpoints so they provide the necessary responses to 
      complete the client-side requests of the front-end web application.
        `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Introduction to Microservices",
          featureDescription: `Learn to distinguish the benefits of a microservice 
          architecture versus a monolithic architecture. Learn to Compare and contrast 
          different services as a viable option for building microservices in Azure. 
          You will also be able to outline the different microservices patterns in 
          Azure, identify various compute options for microservice like Kubernetes 
          Service, Docker, and Function 
          (as a Service) and alsoIdentify the costs of implementing microservices
          `,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Serverless Functions",
          featureDescription: `Learn to Define Azure Functions as well as common bindings 
          and triggers, to create Azure Functions in the Azure CLI and VS IDE, to create 
          a MongoDB database in CosmosDB and connect it with
          Azure Functions. And you will also secure an API endpoint with 
          function-level authorization keys.
         `,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Enterprise Logic Apps and Event Grid",
          featureDescription: `You will learn to create an Event Grid Topic in Azure Portal. 
          And also apply Event Grid output binding for Azure Functions. You will create a workflow by using 
          Azure Logic Apps. Learn to design a Logic App workflow for email.
         `,
        },
        {
          featureIcon: Icon8,
          featureTitle: "Deploying Your Services",
          featureDescription: `You will learn to deploy API endpoints in Azure CLI to Azure, deploy a 
          client-side Flask application to App Services. You will learn to dockerize an application 
          to a container and upload it to 
          Azure Container Registry. And deploy a client-side application to Kubernetes Service in Azure.
         `,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "Azure Migration",
      unitTag: `Introduction to Cloud Migration, Migrating Web Applications, 
      Migrating Database Workload, Migrating Background Job Processing Service
      `,
      unitDescription: `
      This course focuses on the techniques, processes, and nuances of 
      migrating an existing application to Azure. It will cover the whole 
      end-to-end process of an Azure migration from predicting costs of the
      migration to refactoring the code to ensure the application and corresponding 
      databases are compatible with Azure. In addition, the course walks through 
      best practices of the different application components migrated to Azure: 
      web applications, background processes, and databases.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Introduction to Cloud Migration",
          featureDescription: `You will learn to assess cloud migration needs, 
          And also identify different types of migration and their use cases. 
          You will learn to implement a migration plan using the migration cycle.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Migrating Web Applications",
          featureDescription: `You will be taught to assess web application migration 
          paths with cost prediction and will also learn to migrate existing web 
          applications to Azure Web App. The training will 
          cover how to migrate a web application using lift and shift method.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Migrating Database Workload",
          featureDescription: `You will assess Azure Database options with cost prediction, 
          And learn to migrate a database using Azure Database Migration Service. 
          You will also lean to manually migrate a database from backups.
          `,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Migrating Background Job Processing Service",
          featureDescription: `The training will teach you about the architect offline 
          background job services with cost prediction. You will also learn to migrate 
          services to Azure Web Jobs, Azure Functions, and 
          Azure Durable Functions. You will lean to Migrate background job services to Azure Batch.
          `,
        },
      ],
    },
    {
      unitId: 11,
      unitTitle: "Azure Performance",
      unitTag: `Application Insights, Application Analytics, Azure Management
      `,
      unitDescription: `
      This course enables students to acquire skills which allow 
      them to collect data about the health & performance of an application, 
      analyze and display the collected data to make informed decisions,
      and create automation to remedy application health or performance issues. You will set up and use;
      Application Insights on a variety of Azure resources, and use the Application Insights SDK in a P
      ython application to collect and transmit data about the application. You’ll also query, 
      transform, and display the collected application data so that the data can easily be 
      analyzed, and use automation in Azure to manage cloud resources.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Application Insights",
          featureDescription: `Set up Application Insights, 
          Configure Application Insights on a VMSS, 
          Configure Application Insights for an AKS cluster, 
          Collect telemetry data          
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Application Analytics",
          featureDescription: `Create an Azure Log Analytics Workspace, 
          Collect and ingest log data, 
          Write queries to return only relevant data of application
           performance, 
          Create reporting charts from data
          `,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Azure Management",
          featureDescription: `Create an Azure Automation Account, 
          Autoscale rules for VMSS, 
          Create a RunBook
          `,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Raphael Gab-Momoh",
      coachRole: "Cloud Engineer, Bairny&Co",
    },
    {
      coachId: 2,
      coachImage: Instructor2,
      coachName: "Jefferson Usianene",
      coachRole: "Enterprise System Engineer, Zenith Bank",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Lectures & Lab",
      modelDescription: (
        <>
          <ul className="list-outside ml-3 space-y-2 list-disc">
            <li>Weekend classes</li>
            <li>Intensive training </li>
            <li>Designed to focus on real cases</li>
          </ul>
        </>
      ),
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Projects and Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Work on more 8+ capstone projects </li>
          <li>Develop multiple cloud projects</li>
          <li>Get real-time feedback from coaches</li>
        </ul>
      ),
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Virtual Apprenticeship",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Real projects designed by companies</li>
          <li>Minimum of 5 Virtual projects</li>
          <li>Submit to supervisors</li>
          <li>2 month virtual apprenticeship</li>
        </ul>
      ),
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Job and Career Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>1 month coaching on jobs</li>
          <li>Start applying to roles</li>
          <li>Demo sessions on interviews</li>
        </ul>
      ),
    },
    {
      modelId: 5,
      modelIcon: BusinessImage,
      modelTitle: "A Life Time Access",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Access to our recorded classes</li>
          <li>Access to the Utiva community </li>
        </ul>
      ),
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: Testimony2,
      firstname: "Kenchukwu",
      lastname: "Okoli",
      company: "Cloud Fellow",
      testimony: `
      My Cloud developers learning with Utiva has been very intense. I have 
      been drilled with the necessary skills and attitude that a cloud developer 
      practicing in the industry  should have. Areas covered in the training are 
      areas in cloud computing that existing cloud service providers use to 
      carry out their day to day task. Tutoring is being led by experienced cloud 
      expert currently practicing in the industry. He has given us practical cloud 
      projects to execute and write technical report and blogs about what we have 
      learnt, this is to reinforce the knowledge so that it sticks. It's been so beneficial. 
      I wish the program never ends. 
      Everyone should hurry and join the Utiva community now.   
      `,
    },
    {
      id: 2,
      linkedIn: "https://www.linkedin.com/in/isdon-obioma-agu-11068521b/",
      image: Testimony1,
      firstname: "Isdon",
      lastname: "Obi",
      company: "Cloud Fellow ",
      testimony: `
      Cloud Developers program have been a lovely journey so far. At first I 
      didn't know what to expect and what it was all about, apart from my knowledge 
      of icloud. There was little or  nothing I knew about cloud development. Utiva 
      have made the journey quite exciting, from knowing nothing 
      in cloud development space to knowing so much. All  thanks to utiva.
      `,
    },
  ],

  portofolio: {
    title: "Build and Showcase Your Cloud Developer Portfolio Project",
    description: `
    To earn your Cloud Developer certification, showcase everything 
    you've learned by deploying projects on Github . Every week, 
    you'll be provided with clear steps to iteratively develop your 
    final project. By the end of the course, you'll have created alerts to trigger auto-scaling 
    on an Azure Kubernetes Service (AKS) cluster and trigger a Runbook to execute.
      `,
    name: "Olatunji Abayomi",
    // image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Cloud Developer Certification",
    description: `
    Upon completing Utiva's Cloud Developers Course, you'll receive an 
    industry-recognized, professional Cloud Computing certification 
    to share with your network and showcase all 
    that you've learned. Utiva certificates are formatted for sharing on LinkedIn.
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",

  otherCourses: [
    {
      id: 1,
      courseTitle: "Data Science Bootcamp",
      courseDescription: `At Utiva, you can earn a Data Science 
      certificate that will position you as the next Data Science 
      talent in the tech industry. Learn the foundations of Data 
      Science, Python, data visualizations, modelling, machine learning, 
      and more.`,
      courseUrl: "/courses/data-science-bootcamp",
    },
  ],
};
